import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
declare var $: any;
@Component({
  selector: 'app-score-management',
  templateUrl: './score-management.component.html',

})
export class ScoreManagementComponent implements OnInit {

  isMobile: boolean = true;
  isOTP: boolean = false;
  isDone: boolean = false;
  isOwnership: boolean = true;
  isSubmitted = false;
  loggedInUser: any;
  roleTypeStr: any;
  securityStatusBg: string = "#FDDDDD";
  securityStatusClr: string = "#FF4B2B";

  privacyStatusBg: String = "#DEE9FE";
  privacyStatusClr: String = "#3F3F3F";
  addUserErrorMessage: any;
  sendCommanddto: SendCommandDto = new SendCommandDto();
  deviceCount: any;
  myuserName: any;
  constructor(private formBuilder: FormBuilder, private router: Router,
    private _service: ApiService, private _toastr: ToastrService, private translate: TranslateService) { }
  childData: any
  selectedLanguage: any
  userResponse: any = [];
  selectedIndex: number = 0;
  getFirstIndexData: any;
  enableGridView: boolean = false;
  isGridView: boolean = true;
  isTreeView: boolean = false;
  s3Url: any;
  noDeviceFount: boolean = false;
  deleteUserResponseMessage: any;
  privacyRecommendations: any[] = [];
  securityRecommendations: any[] = [];
  secprivacyRecommendation: any[] = [];
  deleteSuccess: boolean = false;
  isLoading: boolean = false;
  ngAfterViewInit() {
    this.selectedIndex = 0;
  }
  ngOnInit(): void {
    this.enableGridView = true;
    scrollTo(0, 0)
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);
    }
    if (this.loggedInUser.roleType != 'CHILD') {
      this.getAllUser();
    } else {
      let userObj = {
        id: this.loggedInUser.id,
        avatarUrl: this.loggedInUser.avatarUrl,
        name: this.loggedInUser.name
      };
      this.userResponse.push(userObj);
      this.getScoreManagement(userObj, this.selectedIndex);
    }
    this.selectedIndex = 0;
    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this.translate.use(this.selectedLanguage);
    }
  }

  getAllUser() {

    this.isLoading = true;
    try {
      this._service.getService(this._service.API_URL.getMyUsers).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.userResponse = response.data;
          this.getScoreManagement(response.data[0], this.selectedIndex)
          this.getDevicesInUser()
        } else {
          this.isLoading = false;
        }
      }
      )
    }
    catch (error) {
      this.isLoading = false;
    }
  }
  mobileDevice: any[] = []
  getDevicesInUser() {
    this.isLoading = true;
    try {
      this._service.getService(this._service.API_URL.getDevicesInUser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          this.deviceId = response?.data[0]?.id;
        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }
  addDevice() {
    try {
      if (this.userResponse[0].mobileVerified) {
        this.router.navigateByUrl('/home/add-device');
      } else {
        this._service.getService(this._service.API_URL.checkVerifiedMobile).subscribe((response) => {
          if (response && response.status.code === 200) {
            if (response.data == true) {
              this.router.navigateByUrl('/home/add-device');
            }
          } else {
            this.isLoading = false;
            this._toastr.error('', response.status.message);
          }
        })
      }
    } catch (error) {
    }

  }

  ScoreManagementData: any[] = []
  deviceId: any;
  userId: any;
  getScoreManagement(data: any, index: any) {
    this.userId = data.id
    this.isLoading = true;
    this.selectedIndex = index;
    try {
      this._service.getService(this._service.API_URL.getScoreManagement + "?userId=" + data.id).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.ScoreManagementData = response.data;
          this.myuserName = response.data[0].userName;
          this.deviceId = this.ScoreManagementData[0].deviceOrSystemId;
        } else {
          this.isLoading = false;
        }

      })
    } catch (error) {
      this.isLoading = false;
    }
  }
  getColor(val: any) {
    if (val <= 250) {
      return "#FF4B2B";
    } else if (val >= 251 && val <= 500) {
      return "#FAA200";
    } else if (val >= 501 && val <= 800) {
      return "#2144FE";
    } else {
      return "#0DA437";
    }
  }
  securityById(id: any) {
    this.router.navigateByUrl(`/home/security-score/${id}` + '?userId=' + this.userId)
  }

  syncScoreArr: any = []
  openSyncScoreModal(item: any, type: any) {
    this.syncScoreArr = [];
    // console.log(type);
    $("#syncScoreModal").modal("show");
    this.syncScoreArr.push(item, type);
  }

  sendCommandScore(item: any, type: any) {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = item.deviceOrSystemId;
      this.sendCommanddto.requestType = type;
      this.sendCommanddto.productKeyType = item.deviceType;
      this._service.postService(this._service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
          $("#syncScoreModal").modal("hide");
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
          $("#syncScoreModal").modal("show");
        }
      })
    } catch (error) {
    }
  }

  closeModal() {
    $("#syncScoreModal").modal("hide");
  }
}

